// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".category-filter[data-v-27b3255c]:hover,.selectedCategory[data-v-27b3255c]{background:#1c344c!important;color:#fff!important}.background-container[data-v-27b3255c]{background-color:#f9feff}.label-list[data-v-27b3255c]{margin-left:1rem}.recap-card-list[data-v-27b3255c]{padding:0 1.5rem 1.5rem 1.5rem}", ""]);
// Exports
module.exports = exports;
